<template>
    <IconBase :class="classes" view-box="0 0 22 23">
        <path d="M17.9233 8.42308C17.9233 13.0385 11.0002 18.4231 11.0002 18.4231C11.0002 18.4231 4.07715 13.0385 4.07715 8.42308C4.07715 4.65231 7.22946 1.5 11.0002 1.5C14.771 1.5 17.9233 4.65231 17.9233 8.42308Z" stroke="#DBEFFC" stroke-width="1.53846" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
        <path d="M11.0001 10.7307C12.2746 10.7307 13.3078 9.69756 13.3078 8.42305C13.3078 7.14854 12.2746 6.11536 11.0001 6.11536C9.72557 6.11536 8.69238 7.14854 8.69238 8.42305C8.69238 9.69756 9.72557 10.7307 11.0001 10.7307Z" stroke="#DBEFFC" stroke-width="1.53846" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
        <path d="M17.2728 16.1153H18.6923L21 21.4999H1L3.30769 16.1153H4.72723" stroke="#DBEFFC" stroke-width="1.53846" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
    </IconBase>
</template>

<script>
import IconBase from "./IconBase.vue"

export default {
    name: 'IconPinMap',
    components: {
        IconBase
    },
    props: {
        classes: {
            type: String,
            required: false,
            default: ''
        },
    },
}
</script>
